<!--  -->
<template>

  <page pageDataUrl="/api/pageData/page_contact"
        v-on:paddingData="paddingPageData"
        :hasbreadcrumbs="true"
        defPageTitle='联系我们'>

    <div class='content'>
      <h1 class="entry-title">联系我们</h1>

      <div v-if="isSuccess"
           style="    text-align: center;">

        <router-link to="/">
          <div style="display: flex;flex-flow: column;">
            <i class="el-icon-success"
               style="font-size:50px;color:#0066cb"> </i>
            <label style="color:#444;margin-top: 10px;">提交成功</label>
            <label style="color:#444;margin-top: 10px;">返回首页</label>
          </div>
        </router-link>
      </div>
      <div v-if="!isSuccess">

        <div style="display: flex;">
          <div v-for="(company , index) in companys"
               class="company-info2"
               :style="{width:'calc(100% / '+ companys.length +' - 20px)'}">
            <div style="font-weight: 600;">
              {{company.name}}
            </div>
            <ul style="display: flex;flex-wrap: wrap;width:320px;">
              <li style="folat:left;margin:0 10px 0 0;"
                  v-for="(tell ,tIndex) in company.tells">
                <a style="color: #444;"
                   :href="'tel:'+tell.tell">{{tell.tell}}</a>({{tell.key}})
              </li>
            </ul>
            <p style="font-size:95%;margin-top:3px;">邮箱：<a :href="'mailto:'+company.email"
                 style="color: #0066CB;font-weight: 600;">{{company.email}}</a></p>
            <p style="font-size:95%;margin-top:3px;">人事：<a :href="'mailto:'+company.hrEmail"
                 style="color: #0066CB;font-weight: 600;">{{company.hrEmail}}</a></p>

            <p style="font-size:95%;margin-top:3px;">
              地址：{{company.address}}
            </p>
          </div>

          <!-- <el-row :gutter="20" >
            <el-col :span="8" class="company-info"
                    v-for="(company , index) in companys">
              <div>
                {{company.name}}
              </div>
              <p>
                地址：{{company.address}}
              </p>
              <ul style="display: flex;flex-wrap: wrap;width:320px;">
                <li style="folat:left;margin:0 10px 0 0;"
                    v-for="(tell ,tIndex) in company.tells">
                    <a style="color: #444;" :href="'tel:'+tell.tell">{{tell.tell}}</a>({{tell.key}})
                </li>
              </ul>
              <p style="font-size:95%"><a :href="'mailto:'+company.email"
                   style="color: #0066CB;font-weight: 600;">{{company.email}}</a>（邮箱）</p>
              <p style="font-size:95%"><a :href="'mailto:'+company.hrEmail"
                   style="color: #0066CB;font-weight: 600;">{{company.hrEmail}}</a>（人事）</p>

            </el-col>
          </el-row> -->
        </div>
        <div style="padding:20px 15px 0;font-size:94%;">
          <p>请填写下面的表格，然后单击“提交”按钮。</p>
          <p style="padding-top:5px;">1、<font style="color:red">【*】</font>是必填字段。</p>
          <p style="padding-top:5px;">2、请填写“查询详细信息”栏目，了解型号信息，机器名称，问题和咨询，型号名称和用途等。</p>
        </div>
        <div class="contact-content">

          <el-form label-width="180px"
                   :rules="contactRules"
                   :model="newData"
                   ref="ruleForm">
            <el-form-item label="公司名称"
                          prop="companyName">
              <el-input v-model="newData.companyName"
                        maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="您的称呼"
                          prop="named">
              <el-input v-model="newData.named"
                        maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱地址"
                          prop="email">
              <el-input v-model="newData.email"
                        maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="确认电子邮箱地址"
                          prop="twoEmail">
              <el-input v-model="newData.twoEmail"
                        maxlength="50"> </el-input>
            </el-form-item>
            <el-form-item label="邮政编码"
                          prop="postcode">
              <el-input v-model="newData.postcode"
                        maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="地址"
                          prop="address">
              <el-input v-model="newData.address"
                        maxlength="128"></el-input>
            </el-form-item>
            <el-form-item label="电话号码"
                          prop="telephone">
              <el-input v-model="newData.telephone"
                        maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="传真号码">
              <el-input v-model="newData.faxNumber"
                        maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="咨询内容"
                          prop="content">
              <el-select v-model="newData.content"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           maxlength="10">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="咨询详情"
                          prop="details">
              <el-input type="textarea"
                        :rows="5"
                        maxlength="512"
                        placeholder="请输入内容"
                        v-model="newData.details">
              </el-input>
            </el-form-item>
            <!-- <el-form-item> -->
            <div style="display: flex;justify-content: center;">
              <el-button @click="resetForm">重置</el-button>
              <el-button type="primary"
                         @click="sumbit">提 交</el-button>
            </div>
            <!-- </el-form-item> -->
          </el-form>
        </div>
      </div>
    </div>

  </page>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

// 根据需要按需引入数据
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      newData: {
        companyName: "",
        named: "",
        email: "",
        twoEmail: "",
        postcode: "",
        address: "",
        telephone: "",
        faxNumber: "",
        content: "",
        details: ""
      },
      companys: [],
      twoEmail: "",
      options: [],
      isSuccess: false,
      contactRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        named: [{ required: true, message: "请输入您的称呼", trigger: "blur" }],
        email: [
          { required: true, message: "请输入电子邮箱地址", trigger: "blur" }
        ],
        twoEmail: [
          { required: true, message: "请输入确认电子邮箱地址", trigger: "blur" }
        ],
        postcode: [
          { required: true, message: "请输入邮政编码", trigger: "blur" }
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        telephone: [
          { required: true, message: "请输入电话号码", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请选择咨询内容", trigger: "change" }
        ],
        details: [
          { required: true, message: "请输入咨询详情", trigger: "blur" }
        ]
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    resetForm() {
      this.$refs["ruleForm"].resetFields();
    },
    sumbit() {
      console.log(this.newData);
      var that = this;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          that.$request.post({
            url: "/api/pageData/add_contact",
            params: that.newData,
            callback: {
              success: function(data) {
                if (data.code === 200) that.isSuccess = true;
              },
              err: function(err) {
                that.isSuccess = false;
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    paddingPageData(data) {
      if (data.data.companys !== undefined)
        for (var i = 0, len = data.data.companys.length; i < len; i++) {
          var company = data.data.companys[i];
          company.infos = JSON.parse(company.infos);
          company.tells = JSON.parse(company.tells);
        }
      this.options = data.data.option;
      this.companys = data.data.companys;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.contact-content {
  padding: 50px 50px 0;
}

.company-info2 {
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
  border: #314478 solid 1px;
  display: table-cell;
  cursor: pointer;
}

.company-info2:hover {
  box-shadow: 0 0 2px #314478;
  border: 1px solid #314478;
}

.contact-content .el-form-item__label {
  font-weight: bold !important;
  color: #444 !important;
  letter-spacing: 0.1em;
  font-size: 96%;
}

.contact-content
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  color: red;
}

.contact-content .el-select {
  width: 100%;
}
</style>